import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useJuryAssessmentsResultCreation, useFind: useJuryAssessmentsResults } =
  getCRUDHooks({
    entityName: 'createJuryAssessmentsResults',
    find: ({ jurySessionId, assessmentId }) =>
      clientApi
        .getOCClient()
        .helpers.learningActivity.jurySessions.id(jurySessionId)
        .assessments.id(assessmentId)
        .results.find(),
    create: ({ jurySessionId, assessmentId, payload = {} }) =>
      clientApi
        .getOCClient()
        .helpers.learningActivity.jurySessions.id(jurySessionId)
        .assessments.id(assessmentId)
        .results.create(payload),
  });

export { useJuryAssessmentsResultCreation, useJuryAssessmentsResults };
